import { createRoot } from 'react-dom/client'

import { getConfig, loadConfig } from './config'
import { Root } from './containers/Root'
import axiosInstance from './service/axios'
import { prepareCustomMessages } from './yup'

import '@fontsource/libre-franklin/300.css'
import '@fontsource/libre-franklin/400.css'
import '@fontsource/libre-franklin/500.css'
import '@fontsource/libre-franklin/700.css'

prepareCustomMessages()

loadConfig().then(() => {
  axiosInstance.defaults.baseURL = getConfig().BE_URL
  const root = createRoot(document.getElementById('root') as HTMLElement)
  root.render(<Root />)
})
